<ng-container *ngIf="trend">
  <span *ngIf="neutralTrend" class="color--grey-500"
    >{{ trend }}<span class="ab-trend__percentage">%</span>
  </span>

  <span
    *ngIf="!neutralTrend"
    [ngClass]="{
      'color--success': isPositiveTrend(trend),
      'color--danger': !isPositiveTrend(trend)
    }"
    >{{ trend }}<span class="ab-trend__percentage">%</span>
  </span>
</ng-container>

<span *ngIf="!trend" class="ab-trend__small color--grey-500"> No change </span>
